import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Communication } from '../../services/communications.service';

@Component({
    selector: 'app-communication-summary-tile',
    templateUrl: './communication-summary-tile.component.html',
    styleUrls: ['./communication-summary-tile.component.sass'],
    standalone: false
})
export class CommunicationSummaryTileComponent {
  @Input() communication!: Communication;

  constructor(private router: Router) {}

  get truncatedBody(): string {
    if (this.communication.body.length <= 100) {
      return this.communication.body;
    }
    return this.communication.body.substring(0, 100) + '...';
  }

  onClick() {
    this.router.navigate(['condominium', this.communication.condominiumId, 'communications', this.communication.id]);
  }
}
